/* eslint-disable @typescript-eslint/explicit-function-return-type */
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Start",
    component: () =>
      import(/* webpackChunkName: "start" */ "@/views/Start.vue"),
    meta: {
      showChat: false
    }
  },
  {
    path: "/age-selection",
    name: "Age Selection",
    component: () =>
      import(/* webpackChunkName: "instructions" */ "@/views/AgeSelection.vue"),
    meta: {
      showChat: false
    }
  },
  {
    path: "/questionnaire",
    name: "Questionnaire",
    component: () =>
      import(
        /* webpackChunkName: "questionnaire" */ "@/views/Questionnaire.vue"
      ),
    meta: {
      showChat: false
    }
  },
  {
    path: "/instructions",
    name: "Instructions",
    component: () =>
      import(
        /* webpackChunkName: "recommendation" */ "@/views/Instructions.vue"
      ),
    meta: {
      showChat: false
    }
  },
  {
    path: "/before-after",
    name: "Before and After",
    component: () =>
      import(
        /* webpackChunkName: "recommendation" */ "@/views/BeforeAfter.vue"
      ),
    meta: {
      showChat: false
    }
  },
  {
    path: "/wrinkle-selection",
    name: "Wrinkle Selection",
    component: () =>
      import(
        /* webpackChunkName: "recommendation" */ "@/views/WrinkleSelection.vue"
      ),
    meta: {
      showChat: false
    }
  },
  {
    path: "/recommendation",
    name: "Recommendation",
    component: () =>
      import(
        /* webpackChunkName: "recommendation" */ "@/views/Recommendation.vue"
      ),
    meta: {
      showChat: false
    }
  },
  {
    path: "/finish",
    name: "Finish",
    component: () =>
      import(/* webpackChunkName: "recommendation" */ "@/views/Finish.vue"),
    meta: {
      showChat: false
    }
  },
  {
    path: "/privacy-tos",
    name: "Privacy",
    component: () =>
      import(/* webpackChunkName: "privacy" */ "@/views/Privacy.vue"),
    meta: {
      showChat: false,
      hideCookieBanner: true
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
